import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'parameter'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/parameter`

class ParametersService {
  about () {
    return Api().get(`${root}/about`)
  }

  insert (item) {
    return Api().post(root, item)
  }

  update (item) {
    return Api().put(`${root}/${item.parameterName}`, item)
  }

  findAll () {
    return Api().get(clientRoot())
  }

  delete ({ parameterName }) {
    return Api().delete(`${clientRoot()}/${parameterName}`)
  }

  findById (id) {
    const url = `${clientRoot()}/${id}`
    return Api().get(url)
  }
}

export default new ParametersService()
